import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { LoginPage, ProxyPage, TenureCheckPage } from '@pages';
import { AuthLayout } from '@features/shared';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthLayout marginTop="20rem" />,
    children: [
      { path: 'ciam-login', element: <LoginPage />, loader: () => (document.title = 'CIAM Login') },
      { path: 'ciam-tenure-check', element: <TenureCheckPage />, loader: () => (document.title = 'CIAM Tenure Check') },
      { path: 'ciam-proxy', element: <ProxyPage />, loader: () => (document.title = 'CIAM Proxy') },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
